import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const CallIcon = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            fill="none"
            viewBox="0 0 24 24"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                stroke="currentColor"
                d="M9.616 8.236a1.894 1.894 0 0 0 0-2.676L7.608 3.554a1.892 1.892 0 0 0-2.676 0l-1.1 1.102a2.833 2.833 0 0 0-.36 3.571 44 44 0 0 0 12.3 12.301 2.839 2.839 0 0 0 3.573-.357l1.1-1.102a1.891 1.891 0 0 0 0-2.676l-2.007-2.007a1.893 1.893 0 0 0-2.676 0l-.67.67a44.896 44.896 0 0 1-6.145-6.149l.669-.67Z"
            />
        </svg>
    </IconWrapper>
)
